import styled from 'styled-components'

import { Media } from '../../style'

export const Arrow = styled.img`
  margin-top: 20px;
  ${Media.lessThan(Media.small)} {
    display: none;
  }
`
